import * as React from 'react';
import clsx from 'clsx';
import { ChevronDown, ChevronUp, Minus, Plus, X } from 'lucide-react';
import { Base } from '../Base';
import { SrOnly } from '../Helper';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "AddonButton-root_3T2j8",
  "icon": "AddonButton-icon_14mWK",
  "size-m": "AddonButton-size-m_3BqNq",
  "size-s": "AddonButton-size-s_29vPJ",
  "size-xs": "AddonButton-size-xs_3xEyW",
  "size-xxs": "AddonButton-size-xxs_KQ2Dt",
  "hitzone-flow": "AddonButton-hitzone-flow_si9Lm",
  "hitzone-overlay": "AddonButton-hitzone-overlay_1NlSb",
  "mode-light": "AddonButton-mode-light_2MLk6",
  "active": "AddonButton-active_2W4Uv",
  "mode-dark": "AddonButton-mode-dark_2ThMP",
  "disabled": "AddonButton-disabled_2JQGc"
};
const iconMap = new Map([['add', Plus], ['subtract', Minus], ['remove', X], ['expand', ChevronDown], ['collapse', ChevronUp]]);
const AddonButton = /*#__PURE__*/React.forwardRef(AddonButton_withRef);
function AddonButton_withRef({
  size = 'm',
  mode = 'light',
  intent = 'add',
  hitzone = 'flow',
  active,
  disabled,
  children,
  className,
  ...extraProps
}, ref) {
  const Icon = iconMap.get(intent);
  return /*#__PURE__*/_jsxs(Base, {
    innerRef: ref,
    tagName: "button",
    type: "button",
    disabled: disabled,
    className: clsx(styles.root, styles[`size-${size}`], styles[`mode-${mode}`], styles[`hitzone-${hitzone}`], {
      [styles.active]: active,
      [styles.disabled]: disabled
    }, className),
    ...extraProps,
    children: [Icon ? /*#__PURE__*/_jsx(Icon, {
      className: styles.icon
    }) : null, /*#__PURE__*/_jsx(SrOnly, {
      children: children
    })]
  });
}
AddonButton.displayName = 'AddonButton';
export { AddonButton };